
const privacyBody = `**1. Responsable du traitement / Verantwortlicher**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Données que nous collectons**

Lorsque vous utilisez le formulaire de contact de ce site, nous collectons les données suivantes : nom, adresse e-mail, trajet d’intérêt et le message que vous nous envoyez. Ces données sont nécessaires pour pouvoir vous répondre.

Le site peut stocker des cookies techniques strictement nécessaires au fonctionnement de base. Nous n’utilisons pas de cookies de suivi ni de publicité tiers.

**3. Finalité du traitement**

Les données du formulaire sont utilisées exclusivement pour répondre à votre demande et gérer votre inscription initiale sur la plateforme. Elles ne sont pas transmises à des tiers sans votre consentement, sauf obligation légale.

**4. Base juridique**

Le traitement repose sur votre consentement (art. 6, par. 1, let. a RGPD) lors de l’envoi du formulaire, et sur l’intérêt légitime de gérer la relation précontractuelle (art. 6, par. 1, let. b RGPD).

**5. Conservation des données**

Les données du formulaire de contact sont conservées le temps nécessaire au traitement de votre demande et, au plus, 12 mois après le dernier contact, sauf si une relation contractuelle ultérieure impose une durée plus longue.

**6. Vos droits**

Vous avez le droit d’accéder à vos données personnelles, de demander leur rectification ou leur effacement, de vous opposer au traitement, de demander la portabilité de vos données et d’introduire une réclamation auprès de l’autorité de protection des données compétente.

Pour exercer vos droits, écrivez-nous à : bringylatam@gmail.com

**7. Hébergement**

Ce site est hébergé chez Cloudflare. Cloudflare peut traiter des données techniques d’accès (adresse IP, navigateur, date et heure) dans le cadre de son service réseau et sécurité. Pour plus d’informations : https://www.cloudflare.com/privacypolicy/

**8. Modifications de cette politique**

Nous pouvons mettre à jour cette politique à tout moment. La version en vigueur sera toujours disponible sur cette page avec la date de dernière mise à jour.`

const impressumBody = `Informations conformément au § 5 TMG / Información según § 5 TMG

**Verantwortlich / Responsable :**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Kontakt / Contact :**
E-Mail: bringylatam@gmail.com
Telefon / Téléphone : [COMPLETAR: +49 ... o número correspondiente]

**Exploitant de la plateforme :**
Bringy
[COMPLETAR: misma dirección legal]

**Numéro de TVA / identifiant fiscal (le cas échéant) :**
[COMPLETAR: DE... o número fiscal del país de registro]

**Avis de responsabilité :**
Bringy agit comme plateforme intermédiaire entre acheteurs et voyageurs. Nous ne sommes pas partie aux transactions entre utilisateurs et n’assumons pas la responsabilité des produits échangés, sauf dans les cas expressément prévus par nos conditions d’utilisation.

Les informations fournies sur ce site ont été compilées avec soin ; toutefois nous ne garantissons pas leur exactitude, exhaustivité ou actualité.

**Règlement des litiges :**
La Commission européenne met à disposition une plateforme de règlement des litiges en ligne : https://ec.europa.eu/consumers/odr
Nous ne sommes pas disposés ni tenus de participer à une procédure de résolution des litiges devant un organisme de médiation de la consommation.`

export const fr = {
  brand: {
    name: 'Bringy',
    tagline: 'De vraies personnes. De vrais produits. Des trajets vérifiés.',
  },
  nav: {
    howItWorks: 'Fonctionnement',
    whyUs: 'Pourquoi Bringy',
    offerings: 'Services',
    faq: 'FAQ',
    contact: 'Contact',
    cta: 'Commencer',
  },
  hero: {
    eyebrow: 'Europe ↔ Amérique du Sud',
    titleAccent: 'Bring',
    titleRest: 'Ce qui compte.',
    subtitle:
      'Nous mettons en relation les personnes qui voyagent entre l’Europe et l’Amérique du Sud avec celles qui ont besoin de produits de l’autre côté. Pas de coursier, pas d’agence — seulement de vraies personnes dont l’identité est vérifiée.',
    ctaBuscar: 'Trouver un produit',
    ctaOfrecer: 'Proposer comme voyageur',
    trustBadges: [
      { label: 'Identité vérifiée' },
      { label: 'Paiement sous séquestre' },
      { label: 'Note publique du voyageur' },
      { label: 'Livraison documentée' },
    ],
    boardingPass: {
      passengerLabel: 'PASSAGER',
      brand: 'BRINGY',
      sub: 'TRANSPORT · VÉRIFIÉ · ASSURÉ',
      fromCode: 'BER',
      fromCity: 'BERLIN',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'VOL BR · 2026',
      gate: 'PORTE A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'Bringy est en phase de lancement. Chaque nouveau voyageur est vérifié personnellement par notre équipe.',
    processTitle: 'Avant qu’un voyageur transporte un seul article',
    processIntro:
      'Nous montrons la rigueur du processus — pas de témoignages inventés. C’est ainsi que nous bâtissons la confiance dès le premier jour.',
    stepVerified: 'Vérifié',
    stepPending: 'En attente',
    processSteps: [
      {
        number: '01',
        title: 'Vérification d’identité',
        description: 'Document officiel validé avant toute activité sur la plateforme.',
      },
      {
        number: '02',
        title: 'Accueil en visioconférence',
        description: 'Échange initial avec notre équipe pour expliquer les règles et les attentes.',
      },
      {
        number: '03',
        title: 'Convention de séquestre',
        description: 'Acceptation des conditions de paiement protégé avant la première transaction.',
      },
    ],
    foundingMembers: '{count} voyageurs ont déjà enregistré leur premier trajet',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Pourquoi Bringy',
    headline: 'Quatre garanties.',
    headlineAccent: 'Sans exception.',
    title: 'Pourquoi Bringy fonctionne',
    subtitle:
      'Les solutions informelles existent déjà — groupes WhatsApp, bouche-à-oreille. Bringy fait la même chose, avec l’infrastructure qui manquait.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'CONFIRMÉ',
    cardPending: 'EN ATTENTE',
    cardApproved: '· APPROUVÉ ·',
    cardsMeta: [
      { value: 'IDENTITÉ', field: 'KYC · PASSEPORT' },
      { value: 'ASSURANCE', field: 'JUSQU’À €4.000' },
      { value: 'CONFORMITÉ', field: 'EU · AR · DÉCLARÉ' },
      { value: 'LIVRAISON', field: 'PHOTO · SUIVI' },
    ],
    items: [
      {
        title: 'Confiance vérifiée',
        description:
          'Chaque voyageur passe une vérification d’identité avant d’opérer sur la plateforme. Vous savez avec qui vous traitez.',
      },
      {
        title: 'Votre argent, protégé',
        description:
          'Les fonds restent sous séquestre jusqu’à ce que vous confirmiez la réception du produit. Aucun risque de payer pour quelque chose qui n’arrive pas.',
      },
      {
        title: 'Réputation réelle',
        description:
          'Chaque voyageur accumule un historique de livraisons et des évaluations. Vous pouvez voir sa note avant de coordonner.',
      },
      {
        title: 'Livraison documentée',
        description:
          'Pour plus de sécurité, nous proposons une vérification en direct avec un représentant Bringy par visioconférence.',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · Comment ça marche',
    headline: 'Une piste, pas',
    headlineAccent: 'un processus.',
    tagline: 'Quatre étapes. Une traversée atlantique.',
    title: 'Fonctionnement',
    subtitle: '',
    footerLabels: { status: 'STATUT', eta: 'ETA', lane: 'VOIE' },
    stepMeta: [
      { status: 'EN ATTENTE', eta: '~ 18H', lane: 'A7' },
      { status: 'EN ATTENTE', eta: '~ 36H', lane: 'B8' },
      { status: 'EN ATTENTE', eta: '~ 54H', lane: 'C9' },
      { status: 'EN ATTENTE', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Publiez votre demande',
        description:
          'Décrivez le produit dont vous avez besoin, la destination et ce que vous proposez pour le transport.',
      },
      {
        number: 2,
        title: 'Un voyageur accepte',
        description:
          'Des voyageurs vérifiés avec des trajets actifs voient votre demande et proposent de le transporter lors de leur prochain voyage.',
      },
      {
        number: 3,
        title: 'Vous coordonnez les détails',
        description:
          'Vous convenez du mode de paiement, du lieu de remise et des délais directement avec le voyageur via le chat de la plateforme.',
      },
      {
        number: 4,
        title: 'Vous recevez et confirmez',
        description:
          'Une fois le produit en main, vous confirmez la livraison et le paiement est libéré au voyageur.',
      },
    ],
  },
  manifest: {
    sectionLabel: '04 · Manifeste du jour',
    headline: 'Le tableau,',
    headlineAccent: 'en direct.',
    tagline: 'Tous les envois déclarés.',
    liveLabel: 'En direct · {count} envois aujourd’hui',
    columns: ['Heure', 'De → Vers', 'Envoi', 'Statut', 'Porte'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'MÉDICAMENTS', status: 'ASSURÉ', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ÉLECTRONIQUE', status: 'VÉRIFIÉ', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'CHAUSSURES', status: 'EMBARQUEMENT', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOCUMENTS', status: 'ASSURÉ', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'LIVRES', status: 'ASSOCIÉ', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifeste 2026',
    footerRight: 'Pré-lancement · Routes vérifiées',
  },
  activeRoutes: {
    sectionLabel: '05 · Routes actives',
    headline: "L'Europe décolle.",
    headlineAccent: 'Buenos Aires attend.',
    tagline: "Cinq couloirs. Une direction. On ne transporte que ce qui vole déjà.",
    routePrefix: 'ROUTE',
    originLabel: 'Origine',
    destLabel: 'Destination',
    flightLabel: 'Vol',
    openLabel: 'Ouvert',
    routes: [
      { fromCity: 'Berlin',   fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',   fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Rome',     fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Paris',    fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lisbonne', fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Services',
    title: 'Services',
    buyer: {
      label: 'Pour les acheteurs',
      title: 'Trouvez ce qui n’arrive pas dans votre pays',
      body: 'Publiez ce dont vous avez besoin et connectez-vous à un voyageur vérifié qui fait déjà le trajet. Accédez à des produits aux prix d’origine, sans intermédiaires.',
      cta: 'Publier une demande',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlin → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Rome → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'Paris → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'Pour les voyageurs',
      title: 'Monétisez l’espace libre de vos bagages',
      body: 'Vous voyagez entre l’Europe et l’Amérique du Sud ? Publiez votre trajet et les produits que vous pouvez transporter. Amortissez une partie du voyage et construisez une réputation de voyageur fiable.',
      cta: 'M’inscrire comme voyageur',
      routes: [
        { route: 'Berlin → Buenos Aires', activeTravelers: 'HQ · 3 voyageurs actifs' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 voyageurs actifs' },
        { route: 'Rome → Buenos Aires', activeTravelers: '5 voyageurs actifs' },
        { route: 'Paris → Buenos Aires', activeTravelers: '4 voyageurs actifs' },
        { route: 'Lisbonne → Buenos Aires', activeTravelers: '7 voyageurs actifs' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Questions fréquentes',
    subtitle: '',
    items: [
      {
        question: 'Comment m’inscrire sur Bringy ?',
        answer:
          'Remplissez le formulaire avec votre nom, e-mail et si vous souhaitez acheter ou voyager. Nous vous contactons sous 24 h pour vos premières étapes.',
      },
      {
        question: 'Qui peut être voyageur ?',
        answer:
          'Toute personne majeure qui voyage régulièrement entre l’Europe et l’Amérique du Sud. Une vérification d’identité est requise avant de publier des trajets actifs.',
      },
      {
        question: 'Comment savoir si le voyageur est fiable ?',
        answer:
          'Chaque voyageur dispose d’un profil avec niveau de vérification, historique de livraisons et avis d’autres utilisateurs. Plus d’historique, plus de confiance.',
      },
      {
        question: 'Que devient mon argent si le produit n’arrive pas ?',
        answer:
          'Les fonds restent sous séquestre jusqu’à votre confirmation de réception. En cas de problème, l’équipe Bringy intervient et sert de médiation entre les parties.',
      },
      {
        question: 'Quels produits puis-je demander ?',
        answer:
          'Tout produit légal pouvant voyager en cabine ou en soute selon les règles douanières du pays de destination : électronique, vêtements, cosmétiques, denrées non périssables, documents, etc.',
      },
      {
        question: 'Combien facture Bringy ?',
        answer:
          'Une commission de 8 à 10 % sur chaque transaction réussie. Les voyageurs réguliers peuvent souscrire à Pro pour 9 €/mois, ce qui supprime la commission et offre une visibilité accrue.',
      },
      {
        question: 'Puis-je demander une livraison avec vérification en direct ?',
        answer:
          'Oui. Pour les transactions à plus forte valeur ou si les deux parties le préfèrent, un représentant Bringy rejoint l’échange par visioconférence, vérifie les identités et documente la remise.',
      },
      {
        question: 'Sur quels trajets êtes-vous disponibles ?',
        answer:
          'Nous opérons depuis Berlin (HQ), Madrid, Rome, Paris et Lisbonne — toutes les routes mènent à Buenos Aires. De nouveaux trajets s’ajoutent selon la demande.',
      },
      {
        question: 'Quels moyens de paiement acceptez-vous ?',
        answer:
          'Cartes Visa, Mastercard et Amex. Stripe pour les paiements internationaux par carte depuis tout pays. Virements SEPA en Europe. Mercado Pago en Amérique du Sud. Libération des fonds sous 1–2 jours ouvrés après confirmation de livraison.',
      },
    ],
  },
  globe: {
    cities: ['Berlin ★', 'Madrid', 'Rome', 'Paris', 'Lisbonne', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: 'Une question ou vous voulez nous rejoindre ?',
    subtitle:
      'Nous sommes en phase de lancement et souhaitons connaître votre situation. Complétez le formulaire : un membre de l’équipe vous contacte sous 24 h.',
    emailLabel: 'Vous pouvez aussi nous écrire à',
  },
  footer: {
    copyright: '© {year} Bringy. Tous droits réservés.',
    tagline: 'De vraies personnes. De vrais produits. Des trajets vérifiés.',
    hubBerlin: 'Berlin',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'Fonctionnement',
      whyUs: 'Pourquoi Bringy',
      offerings: 'Services',
      faq: 'Questions fréquentes',
      contact: 'Contact',
      impressum: 'Impressum',
      privacy: 'Politique de confidentialité',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Réalisé par',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Retour à l’accueil',
    placeholderNotice:
      'Champs indiqués [COMPLETAR] en attente de constitution de l’entité juridique.',
    privacy: {
      title: 'Politique de confidentialité',
      body: privacyBody,
    },
    terms: {
      title: 'Conditions d’utilisation',
      body: 'Bringy agit comme plateforme intermédiaire entre acheteurs et voyageurs. L’utilisation implique l’acceptation de la vérification d’identité, du transport uniquement de produits légaux et du règlement des litiges selon les conditions de la plateforme. Texte définitif à publier.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    chooseLanguage: 'Choisir la langue',
  },
  forms: {
    backHome: 'Retour à l’accueil',
    submit: 'Envoyer la demande',
    successTitle: 'Nous avons bien reçu votre demande !',
    successBody:
      'Nous vous contactons dans les prochaines 24 h pour préciser les détails. Bienvenue sur Bringy.',
    fields: {
      name: { label: 'Nom complet', placeholder: 'Votre nom complet' },
      email: { label: 'E-mail', placeholder: 'vous@email.com' },
      role: {
        label: 'Je suis…',
        placeholder: 'Sélectionnez une option',
        buyer: 'Acheteur',
        traveler: 'Voyageur',
      },
      countryRoute: {
        label: 'Trajet d’intérêt',
        placeholder: 'Ex. : Madrid → Buenos Aires',
        other: 'Autre trajet',
      },
      message: {
        label: 'Produit ou message',
        placeholder: 'Dites-nous quel produit vous cherchez ou ce que vous pouvez transporter',
        optional: 'Facultatif',
      },
    },
    errors: {
      required: 'Veuillez remplir ce champ',
      email: 'Saisissez une adresse e-mail valide',
      role: 'Sélectionnez une option',
      submitFailed: 'Impossible d’envoyer le formulaire. Réessayez.',
    },
    sending: 'Envoi en cours…',
    privacyNote:
      'En envoyant, vous acceptez que nous utilisions ces données pour vous contacter au sujet de Bringy. Consultez notre',
    defaultDescriptions: {
      requestItem: 'Demande depuis le formulaire de contact',
      becomeTraveler: 'Inscription voyageur depuis le formulaire de contact',
    },
    requestItem: {
      title: 'Trouver un produit',
      subtitle: 'Dites-nous ce dont vous avez besoin — nous revenons vers vous sous 24 h.',
    },
    becomeTraveler: {
      title: 'Proposer comme voyageur',
      subtitle: 'Indiquez-nous votre trajet — nous revenons vers vous sous 24 h.',
    },
  },
}
